export default class ActiveToggle {
    constructor(toggle) {
        this.toggle = toggle;
        this.icon = toggle.children[0];
        this.onClickHandler = this.onClick.bind(this);
    }

    init() {
        this.toggle.onclick = this.onClickHandler;
    }

    onClick(e) {
        e.preventDefault();

        if (this.toggle.classList.contains('requesting')) {
            return false;
        }

        let self = this,
            field = this.toggle.getAttribute('data-field'),
            value = this.getValue(),
            postData = new FormData(),
            xhr = new XMLHttpRequest();

        this.toggle.classList.add('requesting');

        this.setSpinner(this.icon);

        postData.append(field, value.toString());

        xhr.open('POST', self.toggle.getAttribute('href'), true);
        xhr.dataType = 'json';
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let response = JSON.parse(xhr.responseText),
                    errors = response.errors,
                    errorMsg = '';

                if (errors) {
                    Object.keys(errors).map(function (errorKey) {
                        errorMsg = 'Error(s) for field ' + errorKey + '\n\n';

                        let messages = errors[errorKey];
                        Object.keys(messages).map(function (messageKey) {
                            errorMsg += messageKey + ' - ' + messages[messageKey] + '\n';
                        });

                        alert(errorMsg);
                    });

                    self.setIcon();
                } else {
                    self.toggle.setAttribute('data-value', self.getValue());
                    self.setIcon();
                }

                self.toggle.classList.remove('requesting');
            }
        };
        xhr.send(postData);
    }

    getValue() {
        let val = parseInt(this.toggle.getAttribute('data-value'), 10);

        if (isNaN(val)) {
            return 1;
        } else if (val === 0) {
            return 1;
        } else {
            return 0;
        }
    }

    setIcon() {
        this.icon.classList.remove('fa-circle-o-notch', 'fa-spin', 'text-info');

        if (this.toggle.getAttribute('data-value') === '1') {
            this.icon.classList.add('fa-circle', 'text-success');
        } else {
            this.icon.classList.add('fa-circle', 'text-danger');
        }
    }

    setSpinner() {
        this.icon.classList.remove('text-success', 'text-danger', 'fa-circle');
        this.icon.classList.add('fa-circle-o-notch', 'fa-spin', 'text-info');
    }
}
